import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@core/app-config';
import { HttpService } from '@core/http';
import { REQUEST_ID_HEADER } from '@store/profile/api/profile.api';
import { Observable } from 'rxjs';
import { v4 as uuidV4 } from 'uuid';

type IncomingFlightDetailsRequest = {
  incomingFlightDetails: {
    carrierCode: string;
    currentFlightNumber: string;
    flightDate: string;
    tailNumber: string;
  };
};

type DateTimeString = string;
type FlightLegStatus = {
  actualArrival: DateTimeString;
  actualArrivalOffset: string;
  actualDeparture: DateTimeString;
  actualInDateTime: DateTimeString;
  actualOffDateTime: DateTimeString;
  actualOnDateTime: DateTimeString;
  actualOutDateTime: DateTimeString;
  baggageClaim: string;
  boardingTime: DateTimeString;
  destinationAirport: string;
  destinationGate: string;
  destinationTerminal: string;
  doorCloseTime: DateTimeString;
  equipmentType: string;
  flightNo: string;
  flightStatus: string;
  flightStatusGroup: string;
  originAirport: string;
  originGate: string;
  originTerminal: string;
  scheduledArrival: DateTimeString;
  scheduledArrivalOffset: string;
  scheduledDeparture: DateTimeString;
  scheduledDestinationAirport: string;
  scheduledOriginAirport: string;
  tailNumber: string;
};

export type FlightStatus = {
  isConnecting: boolean;
  isThroughFlight: boolean;
  legs: FlightLegStatus[];
  tripDestination: string;
  tripOrigin: string;
};

export type IncomingFlightDetailsResponse = {
  error?: string | undefined;
  flights?: FlightStatus[] | undefined;
};

@Injectable({ providedIn: 'root' })
export class IncomingFlightDetailsService {
  constructor(
    private appConfig: AppConfigService,
    private httpService: HttpService,
  ) {}

  getIncomingFlightDetails(
    data: IncomingFlightDetailsRequest,
  ): Observable<HttpResponse<IncomingFlightDetailsResponse>> {
    const headers = new HttpHeaders().set(REQUEST_ID_HEADER, uuidV4());

    return this.httpService.postObserveResponse<IncomingFlightDetailsResponse>(
      this.appConfig.incomingFlightDetailsUrl,
      data,
      { headers },
    );
  }
}
